module.exports = __webpack_public_path__ + "img/6.394fa57.jpg";